'use strict'

import { BaseView } from '../../../shared/utils/baseComponent'
import css from './sidenav.styles.scss'
import template from './sidenav.template.pug'

class SideNavController extends BaseView {
  constructor($element, SessionService, $mdSidenav, $mdDialog, $state) {
    'ngInject'
    super($element)
    Object.assign(this, { SessionService, $mdSidenav, $mdDialog, $state })
  }

  $onInit() {
    this.isAdmin = !!this.SessionService.currentUser.isAdmin(this.customer)
    this.mayAccessDocuments = !!this.SessionService.currentUser.mayAccessDocuments(this.customer)
    this.mayAccessReports = !!this.SessionService.currentUser.mayAccessReports(this.customer)
  }

  close() {
    this.$mdSidenav('sidenav').close()
  }

  logout() {
    this.SessionService.clear()
    this.$state.go('login')
  }

  colors(state) {
    if (this.$state.includes(state)) return { background: 'background-hue-1', color: 'primary' }
    return {}
  }

  iconColors(state) {
    if (this.$state.includes(state)) return { color: 'primary' }
    return {}
  }

  openCustomerDialog() {
    const switchCustomerDialog = this.$mdDialog.switchCustomerDialog({
      fullscreen: true,
      locals: {
        customers: this.SessionService.currentUser.customers,
      },
    })
    this.$mdDialog.show(switchCustomerDialog)
  }

  openProfileDialog() {
    const profileDialog = this.$mdDialog.profileDialog({
      fullscreen: true,
    })
    this.$mdDialog.show(profileDialog)
  }

  openSupportDialog() {
    const requestSupportDialog = this.$mdDialog.requestSupportDialog({
      fullscreen: true,
      locals: {
        customer: this.customer,
      },
    })
    this.$mdDialog.show(requestSupportDialog)
  }
}

export const umsSideNav = {
  template: template({ css }),
  bindings: {
    customer: '<',
  },
  controller: SideNavController,
}



// WEBPACK FOOTER //
// ./app/customers/components/sidenav/sidenav.component.js